import { useContext } from 'react';
import { ModalContext } from './context';

export default function useModal() {
  const { pushModal, popModal } = useContext(ModalContext);
  return {
    pushModal,
    popModal,
  };
}
